import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { notError, notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiAlmacenActualizar } from '../../api/apiAlmacenActualizar'
import {
  ALMACEN_INITIAL_VALUES,
  AlmacenBaseProp,
  AlmacenInputProps,
  AlmacenOutputProps,
} from '../../interfaces'
import { almacenActualizarComposeService } from '../../services/almacenActualizarComposeService'
import {
  AlmacenActualizarValidationSchema,
  almacenActualizarValidator,
} from '../../validator/almacenActualizar.validator'
import AlmacenForm from '../AlmacenForm'

interface OwnProps {
  keepMounted: boolean
  open: boolean
  almacen: AlmacenInputProps
  onClose: (value?: AlmacenBaseProp) => void
}

type Props = OwnProps

const AlmacenActualizarDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, almacen, keepMounted, ...other } = props
  const form = useForm<AlmacenInputProps>({
    defaultValues: {
      ...ALMACEN_INITIAL_VALUES,
    },
    resolver: yupResolver<any, any, any>(AlmacenActualizarValidationSchema),
  })
  const confirm = useConfirm()
  /**
   * Actualizacion de almacenes
   * @param values
   */
  const onSubmit: SubmitHandler<AlmacenInputProps> = async (values) => {
    const val = await almacenActualizarValidator(values)
    if (values.codigoSucursal?.codigo != undefined) {
      const valuesModify: AlmacenOutputProps = {
        codigoSucursal: values.codigoSucursal?.codigo,
        nombre: values.nombre,
        ubicacion: values.ubicacion,
        tipo: 'DESPACHO',
        prioridad: 1,
        activo: true,
      }
      if (val.length > 0) {
        notError(val.join('<br>'))
        return
      } else {
        const { confirmed } = await confirm()
        if (!confirmed) return
        swalLoading()
        const resp = await apiAlmacenActualizar(
          almacen.codigoAlmacen,
          valuesModify,
        ).catch((e) => {
          swalException(e)
        })
        if (resp) {
          notSuccess('Actualización exitosa')
          onClose(resp)
          swalClose()
        } else {
          console.log('error')

          // swalClose()
        }
      }
    }
  }
  const onError = (error: any, e: any) => {
    console.error('Error:', error, e)
  }
  useEffect(() => {
    if (almacen && open) {
      form.reset(almacenActualizarComposeService(almacen))
    }
  }, [open])
  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '80vh' } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Editar Almacen</DialogTitle>

      <DialogContent dividers>
        <AlmacenForm form={form} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus color={'error'} size={'small'} onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size={'small'}
          sx={{ mr: 2 }}
          variant={'contained'}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AlmacenActualizarDialog
